import React from 'react'

const ShowError = ({ error }: { error?: any }) => {
  return (
    <div className="mt-20 p-4 sm:p-6 lg:p-8 text-center text-xl w-full">
      {error
        ? error.response?.data &&
          error.response?.data?.data?.attributes?.error?.message
        : 'Something Went wrong'}
    </div>
  )
}

export default ShowError
